import KComponent from '../../core/KComponent'
import Ripple from '../ripple'
import _ from 'lodash'

export default new KComponent({
  name: 'KCarouselIndicator',
  components: {},
  props: {
    type: {
      type: String, // line
      default: '',
    },
    position: {
      type: String,
      default: 'center',
    },
    outside: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    items() {
      return this.$parent.items
    },
    activeIndex() {
      return this.$parent.activeIndex
    },
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleClick(index) {
      this.$emit('click', { index })
    },
  },
  render() {
    const style = {}

    const css = {
      'km-carousel__indicators': true,
      'km-carousel__indicators--line': this.type === 'line',
      'km-carousel__indicators--outside': this.outside,
      [`is-${this.position}`]: true,
    }

    const attrs = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    const hasCustom = this.$scopedSlots.default

    if (hasCustom) {
      return (
        <div {...data}>
          {
            _.map(this.items, (item, index) => {
              return <div
                onClick={() => {
                  this.handleClick(index)
                }}
              >
                {
                  this.$scopedSlots.default({
                    $index: index,
                    activeIndex: this.activeIndex,
                  })
                }
              </div>
            })
          }
        </div>
      )
    }

    return (
      <div {...data}>
        {
          _.map(this.items, (item, index) => {
            return (
              <Ripple
                tag="a"
                class={{
                  'km-carousel__indicator': true,
                  'km-carousel__indicator--active': this.activeIndex === index,
                }}
                nativeOnClick={() => {
                  this.handleClick(index)
                }}
                kCentered={this.type !== 'line'}
              >
                <span></span>
              </Ripple>
            )
          })
        }
      </div>
    )
  },
})
